import { CellContent, CellContentObject, GroupingDefsCell } from './types';

export function isInstanceOfCellContentObject(object: unknown): object is CellContentObject {
  return !!object && typeof object === 'object' && 'value' in object && 'label' in object;
}

export function isInstanceOfGroupingDefsCell(object: unknown): object is GroupingDefsCell {
  return !!object && typeof object === 'object' && 'isHeader' in object && 'group' in object;
}

export function getCellContentValue(content: CellContent): string | number {
  if (isInstanceOfCellContentObject(content)) {
    return content.value;
  }

  if (typeof content === 'string' || typeof content === 'number') {
    return content;
  }

  return '';
}

export function getCellContentLabel(content: CellContent): string | number {
  if (isInstanceOfCellContentObject(content)) {
    return content.label;
  }

  if (typeof content === 'string' || typeof content === 'number') {
    return content;
  }

  return '';
}
